// extracted by mini-css-extract-plugin
module.exports = {"centerBody":"styles_centerBody__2-0vW"};